namespace Solovis.Reports.DataPacks {

    export interface DataPackMountData {
        byMountCodeList: any[];
    }

    export class DataPackTracker {

        private static _instance: DataPackTracker;

        private _pendingDataPackLoadPromise;

        private _mountData: DataPackMountData;

        public static getInstance(): DataPackTracker {
            if (DataPackTracker._instance == null) {
                DataPackTracker._instance = new DataPackTracker();
            }

            return DataPackTracker._instance;
        }

        public async refreshDataPackMountsAsync() {

            if (!this._pendingDataPackLoadPromise) {
                await this._loadDataPackMounts();
            }
            else {
                await this._pendingDataPackLoadPromise;
            }
        }

        public getLatestMountData(): DataPackMountData {
            return Solovis.deepCopy(this._mountData);
        }

        private async _loadDataPackMounts(): Promise<void> {
            let response = await Solovis.Rpc.invoke(
                "~/Rpc/DataSource/GetDataPackMounts",
                { includeDetails: true });

            let newMountData: any = {
            };

            if (response.result) {
                newMountData.byMountCodeList = response.result.byMountCode;
            }

            this._mountData = newMountData;
        }

        public tryFindFirstMountWithDescriptionByMountCode(mountCode) {
            let mountData = this._mountData;
            if (mountData && mountData.byMountCodeList) {
                for (let entry of mountData.byMountCodeList) {
                    if (entry.mountCode === mountCode) {
                        if (entry.mounts) {
                            for (let mount of entry.mounts) {
                                if (mount.valueSource) {
                                    return mount;
                                }
                            }
                        }
                    }
                }
            }

            return null;
        }

        public tryFindFirstMountByPackId(packId) {
            let mountData = this._mountData;
            if (mountData && mountData.byMountCodeList) {
                for (let entry of mountData.byMountCodeList) {                    
                    if (entry.mounts) {
                        for (let mount of entry.mounts) {
                            if (mount.packId === packId) {
                                return mount;
                            }
                        }                        
                    }
                }
            }

            return null;
        }
    }

}